import React from 'react';

import { Formik, Form, FormikValues } from 'formik';
import * as yup from 'yup';

import Field from 'components/Field';
import Input from 'components/Input';
import Header from 'components/LogoHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, AcceptButton, Body, GroupButton, TextHeader } from './styles';

export interface Props {
  loading: boolean;
  onSubmit: (username: string) => void;
}

const ForgotPassword = ({ loading, onSubmit }: Props) => {
  const { t } = useStoreTranslation();

  const handleSubmit = (data: { username: string }) => {
    onSubmit(data.username);
  };

  const validationSchema = yup.object().shape({
    username: yup.string().required(),
  });

  const initialValues = {
    username: '',
  };

  return (
    <Container>
      <Formik
        initialStatus={{ rightCheckIfIsValid: true }}
        initialValues={initialValues}
        isInitialValid={(formik: any) => validationSchema.isValidSync(formik.initialValues)}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isValid }: FormikValues) => (
          <Form>
            <Header />
            <Body>
              <TextHeader>
                <h3>{t('forgotPassword.title')}</h3>
              </TextHeader>
              <Field name="username" labelKey="forgotPassword.username">
                <Input
                  id="username"
                  type="text"
                  placeholder={t('forgotPassword.usernamePlaceholder')}
                  autoCapitalize="off"
                  autoCorrect="off"
                />
              </Field>
              <GroupButton>
                <AcceptButton disabled={!isValid || loading} value={t('forgotPassword.submitButton')} loading={loading} />
              </GroupButton>
            </Body>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default ForgotPassword;
